<template>
  <div class="flex flex-wrap col-12 border-box white-bg body-padding-desktop">
    <div class="flex flex-column col-12 my1">
      <span class="h4 bolder">Personne qui utilise l'abonnement :</span>
      <!-- DESKTOP -->
      <div class="flex flex-column col-12 xs-hide light-grey-bg border-grey my2 p1">
        <span class="h5">{{ participantName }}</span>
        <div class="flex col-12 justify-between mb1">
          <span class="h6">{{ subscriptionParticipant.birth_date }}</span>
          <span class="h6">{{ participantCellContact }}</span>
          <span class="h6">{{ subscriptionParticipant.zip_code }}</span>
          <span class="h6">{{ subscriptionParticipant.email }}</span>
        </div>
        <span class="h6 red bold fit-content pointer" @click="changeParticipant">Modifier</span>
      </div>
      <!-- MOBILE -->
      <div class="flex col-12 lg-hide md-hide sm-hide mt2 mb3 justify-between">
        <div class="flex flex-column">
          <span class="h5">{{ participantName }}</span>
          <span class="h6">{{ participantCellContact }}</span>
        </div>
        <div class="pr2">
          <span class="h6 red bold fit-content pointer" @click="changeParticipant">Modifier</span>
        </div>
      </div>
      <!-- Item -->
      <span class="flex col-12 h4 my2 bolder">{{ offer.name }}</span>
      <div class="flex flex-wrap col-12">
        <div class="flex col-12 mt1 mb2 justify-between">
          <span class="h5 bolder">A payer aujourd’hui</span>
          <div>
            <span :class="['h5 bolder', {'crossed': paymentInfo.hasPromo}]">{{ paymentInfo.firstPayment }}</span>
            <span v-if="paymentInfo.hasPromo" class="h5 bolder"> {{ paymentInfo.promo.firstPaymentPromo }}</span>
            <span class="h5 bolder">€</span>
          </div>
        </div>
        <div class="flex col-12 justify-between">
          <span class="h5">Abonnement - {{ tariff.label }}</span>
          <div>
            <span :class="['h5', {'crossed': computePromo(tariff).canShow}]"> {{ computePrice(tariff.price) }}</span>
            <span v-if="computePromo(tariff).canShow" class="h5"> {{ computePrice(computePromo(tariff).price) }}</span>
            <span class="h5">€/mois</span>
          </div>
        </div>
        <div v-for="(option, index) in tariffOptions" :key="index" class="flex col-12 my1 justify-between">
          <span class="h5">{{ option.label }}</span>
          <span class="h5"> {{ option.price }}</span>
        </div>
        <div class="flex flex-wrap col-12 mt3 mb1 justify-between">
          <span class="h5 bolder">Puis</span>
          <div>
            <span :class="['h5 bolder', {'crossed': paymentInfo.hasPromo}]">{{ paymentInfo.recurringPayment }}</span>
            <span v-if="paymentInfo.hasPromo" class="h5 bolder"> {{ paymentInfo.promo.recurringPaymentPromo }}</span>
            <span class="h5 bolder">€/mois</span>
          </div>
          <span class="col-12 h6 italic">Chaque mensualité sera prélevée à la date d’anniversaire de la commande.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeToPage, computePromo, subscriptionPaymentInfo } from '@/utils/logics';
import { computePriceLabel } from '@/utils/utils';

export default {
  props: { canShowCgiError: Boolean },
  data () {
    return {
      offer: this.$store.state.offerInfo,
      cgi: false
    };
  },
  computed: {
    cartItem () {
      return this.$store.state.cartItem;
    },
    paymentInfo () {
      return subscriptionPaymentInfo();
    },
    subscriptionParticipant () {
      return this.cartItem.participants[0] || {};
    },
    participantName () {
      return `${this.subscriptionParticipant.firstname} ${this.subscriptionParticipant.lastname}`;
    },
    participantCellContact () {
      return this.subscriptionParticipant.mobilephone || this.subscriptionParticipant.tellphone;
    },
    tariff () {
      return this.cartItem && this.cartItem.tariffs && this.cartItem.tariffs.length ? this.cartItem.tariffs[0] : [];
    },
    tariffOptions () {
      return this.tariff && this.tariff.options ? this.tariff.options.map(option => {
        if (option.detail && option.price) {
          return ({ label: option.name, price: option.detail.recurring ? `${this.computePrice(option.price.price)}€/mois` : `${this.computePrice(option.price.price)}€` });
        }
        return null;
      }) : [];
    }
  },
  watch: {
    cgi: function (newVal, _oldVal) {
      this.$emit('updateCgi', newVal);
    }
  },
  mounted () {
    this.$store.commit('setSubscriptionHeader', { title: 'Récapitulatif d\'achat & paiement' });
  },
  methods: {
    computePromo,
    computePrice (price) {
      return computePriceLabel(price);
    },
    changeParticipant () {
      changeToPage('NewTDAParticipantSubscription');
    }
  }
};

</script>

<style scoped>

</style>
